import React, { useEffect, useState } from "react";
import ManageOutgoingMailcontainer from "../../../containers/ManageOutgoingMailsContainer/ManageOutgoingMailsContainer";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import { Typography } from "@mui/material";

const ManageOutgoingMail = () => {
  const tRP = "components.outgoing_mail";
  const { t } = useTranslation();
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    <>
      {portalHeader &&
        ReactDOM.createPortal(
          <>
            <Typography
              variant="h3"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {`${t(`${tRP}.title`)}`}
            </Typography>
          </>,
          portalHeader
        )}
      <ManageOutgoingMailcontainer />
    </>
  );
};

export default ManageOutgoingMail;
